<script setup>
import EhTalkChat from './components/EhTalkChat.vue';
</script>

<template>
  <router-view></router-view>
  <EhTalkChat />
</template>
